import { downloadFile } from 'feature/utils/downloaderSlice';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';

type FileOpener = {
	url: string;
	fileName?: string;
	allowDownload?: boolean;
};

export const useFileOpener = () => {
	const dispatch = useDispatch<AppDispatch>();
	return useCallback(
		({ url, fileName = 'download', allowDownload = false }: FileOpener) => {
			dispatch(downloadFile({ url, fileName, allowDownload }));
		},
		[dispatch],
	);
};
